import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-text small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.news, (newsData) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "card mb-2",
      key: newsData
    }, [
      (!newsData.extension.legacyIcon)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: { name: 'Extension', params: { name: newsData.extension } }
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: this.imgUrl(newsData.extension),
                class: "card-img-top",
                alt: newsData.extensionData.name
              }, null, 8, _hoisted_1)
            ]),
            _: 2
          }, 1032, ["to"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("small", null, _toDisplayString(newsData.date), 1),
        _createElementVNode("h6", _hoisted_3, _toDisplayString(newsData.extensionData.name) + " " + _toDisplayString(newsData.version) + " released", 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(newsData.text), 1)
      ])
    ]))
  }), 128))
}